export function buildRedirectUrl(redirectUrl, { i18n, token }) {
  const url = new URL(redirectUrl);
  const hashParams = new URLSearchParams(url.hash.replace(/^#/, ""));

  hashParams.set("i18n", i18n);
  hashParams.set("token", token);

  url.hash = hashParams.toString();
  return url.toString();
}
